import { GraphQLError } from "graphql"
import { groq } from "next-sanity"

import { AppSettings } from "@/settings"

import { checkPermissions } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"

// Query to fetch order (cash) return details by order ID
export const queryOrderReturn = {
  async orderReturn(_parent, args, context, _info) {
    const { orderId, isCashReturn = false, lang, cdn } = args
    const { user, sanityClient } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.ORDERS,
      operation: Operations.READ,
    })

    const config = AppSettings.sanityConfigByLang(lang)
    const client = sanityClient
    client.config({ ...config, useCdn: cdn })

    const type = isCashReturn ? `_type=="orderCashReturn"` : `_type=="orderReturn"`
    const draftsFilter = `&& !(_id in path("drafts.**"))`

    const orderReturn = await client.fetch(
      groq`*[${type} && _id==$orderId ${draftsFilter}][0] {
        _id,
      }`,
      { orderId },
    )

    if (!orderReturn) {
      throw new GraphQLError("ORDER_RETURN_NOT_FOUND", {
        extensions: {
          code: "NOT_FOUND",
        },
      })
    }

    return { id: orderReturn._id }
  },
}
